export const SOURCE_OPTIONS = {
  physical: { id: 'physical', label: 'Physical' },
  digital: { id: 'digital', label: 'Digital' },
  synch: { id: 'synch', label: 'Synchronization (Master and publishing)' },
  synch_master_only: {
    id: 'synch_master_only',
    label: 'Synchronization (Master side only)',
  },
  neighbouringrights: {
    id: 'neighbouringrights',
    label: 'Neighbouring rights',
  },
  other: { id: 'other', label: 'Other' },
  generallicensing: { id: 'generallicensing', label: 'General licensing' },
}
export const SOURCE_PLACEHOLDER = 'Select revenue source'
export const CURRENCY_PLACEHOLDER = 'Select currency'
